<template>
  <CMSLink
    v-if="blok.link"
    :cms-link="transformLink"
    class="text-lg leading-6 tracking-normal hover:text-gold lg:tracking-wider"
    :class="{
      'font-medium': blok.property === 'regular',
      'font-bold': blok.property === 'bold',
      'font-medium text-red': blok.property === 'red',
    }"
    @click="$emit('click', $event)"
  >
    {{ blok.label }}
  </CMSLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
import type { SbNavigationItem } from '~/cms/storyblok/types/storyblok'
import { resolveStoryblokLink } from '#layers/base/utils/storyblok'

const props = defineProps({
  blok: {
    type: Object as PropType<SbNavigationItem>,
    required: true,
  },
})

defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()

const transformLink = computed(() => {
  if (!props.blok.link) {
    return {}
  }

  return {
    ...props.blok.link,
    cached_url: resolveStoryblokLink({ link: props.blok.link }),
    linktype: 'story' as const,
  }
})
</script>
